import { render } from "./CarouselCommentsSlide.vue?vue&type=template&id=4a8e0fee&scoped=true"
import script from "./CarouselCommentsSlide.vue?vue&type=script&lang=js"
export * from "./CarouselCommentsSlide.vue?vue&type=script&lang=js"

import "./CarouselCommentsSlide.vue?vue&type=style&index=0&id=4a8e0fee&lang=scss&scoped=true"

import exportComponent from "C:\\GoogleDrive\\Projects\\Vue\\_published\\ksaien\\ksaien\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8e0fee"]])

export default __exports__